import { render, staticRenderFns } from "./Development.vue?vue&type=template&id=1f8e763f"
import script from "./Development.vue?vue&type=script&lang=js"
export * from "./Development.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports